<template>
  <div>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: "app",
};
</script>
<style lang="scss">
@import "@/assets/color-scheme.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
